import * as React from 'react';
import { MenuItem as MenuItemType, MenuItemData, SubMenu as SubMenuType } from 'moduleBase/types/Menu';
import { SubMenu } from 'moduleBase/components/menu/SubMenu';
import { MenuItemCounter } from 'moduleBase/components/menu/MenuItemCounter';
import { When } from 'react-if';
import { NavLink } from 'components/router/NavLink';
import { useNetworkService } from 'hooks/use-network-service';
import { FC } from 'react';
import { MenuItemContent } from './MenuItemContent';

type PropsType = Omit<MenuItemType, 'items' | 'isVisibleDesktop'> & {
  onClick?: () => void;
  className?: string;
  imageWidth?: number;
  imageClassName?: string;
  subMenu?: SubMenuType;
  subMenuDynamic?: SubMenuType;
  buildNavLinkProp?: (url: string, data: MenuItemData) => object;
  activeId?: string[] | null;
};

const MenuItem: FC<PropsType> = ({
  label,
  id,
  route,
  async,
  url,
  target,
  badge,
  image,
  icon,
  counter,
  onClick = null,
  className = null,
  subMenu = null,
  subMenuDynamic = null,
  imageWidth = null,
  imageClassName = 'dropdown-flat-list__icon',
  buildNavLinkProp = null,
  data,
  activeId = null,
  visible,
  notify,
}) => {
  if (!visible) {
    return null;
  }

  const networkService = useNetworkService();

  const isActive = () => activeId && activeId.includes(id);

  if (!url) {
    return (
      <>
        <span className={className}>
          {label}
        </span>
        <SubMenu subMenu={subMenu} />
      </>
    );
  }

  const handlerClick = (e) => {
    if (async) {
      e.preventDefault();
      networkService.get(url).then(() => {
        window.location.href = process.env.BASE_URL;
      });
      return;
    }

    if (onClick) {
      onClick();
    }
  };

  if (!async && route) {
    const additionalProps = buildNavLinkProp ? buildNavLinkProp(url, data) : null;
    return (
      <>
        <NavLink
          to={url}
          id={id}
          className={className}
          onClick={handlerClick}
          isActive={isActive}
          {...additionalProps}
        >
          <MenuItemContent
            label={label}
            badge={badge}
            icon={icon}
            image={image}
            imageWidth={imageWidth}
            imageClassName={imageClassName}
            notify={notify}
          />
        </NavLink>
        <MenuItemCounter counter={counter} />
        <SubMenu subMenu={subMenu} activeId={activeId} />
        <When condition={isActive()}>
          <SubMenu subMenu={subMenuDynamic} activeId={activeId} />
        </When>
      </>
    );
  }

  return (
    <>
      <a href={url} id={id} className={className} target={target} onClick={handlerClick}>
        <MenuItemContent
          label={label}
          badge={badge}
          icon={icon}
          image={image}
          imageWidth={imageWidth}
          imageClassName={imageClassName}
          notify={notify}
        />
      </a>
      <MenuItemCounter counter={counter} />
      <SubMenu subMenu={subMenu} />
    </>
  );
};

export { MenuItem };
